<template>
    <div class="left-safe">
        <div class="safe-head">
            <img src="@/assets/img/icon/head60.png" alt="" />
            <div class="username">
                <p>你好，</p>
                <h2 v-text="form.personalName">三宝</h2>
            </div>
        </div>
        <div class="safe-body">
            <div class="body-left">
                <p>登录账号：</p>
                <p>注册时间：</p>
                <p>安全级别：</p>
            </div>
            <div class="body-right">
                <p v-text="form.passportName"></p>
                <p v-text="form.registerTime"></p>
                <progressbar
                    :barwidth="barwidth"
                    style="margin-top:12px"
                ></progressbar>
                <ul>
                    <li :class="{ 'level-one': showOne }">惨不忍睹</li>
                    <li :class="{ 'level-two': showTwo }">再接再厉</li>
                    <li :class="{ 'level-three': showThree }">坚如磐石</li>
                </ul>
            </div>
        </div>
        <div class="safe-footer" v-show="prompt">
            <img src="@/assets/img/login/wt.png" alt="" />
            你的账号存在较大安全风险，开启所有安全验证可以有效防御！
        </div>
    </div>
</template>
<script>
import progressbar from "./progressBar";
import { mapState } from "vuex";
export default {
    name: "safeLfet",
    components: {
        progressbar
    },
    data() {
        return {
            barwidth: 0,
            showOne: false,
            showTwo: false,
            showThree: false,
            prompt: true
        };
    },
    computed: {
        ...mapState({
            form: state => state.user.userInfo
        })
    },
    methods: {
        safe() {
            let i = 0;
            if (this.form.wxBind == true) {
                i++;
            }
            if (this.form.saveType == 1) {
                i++;
            }
            if (i == 0) {
                this.barwidth = 1;
                this.showOne = true;
                this.showTwo = false;
                this.showThree = false;
            } else if (i == 1) {
                this.barwidth = 2;
                this.showOne = false;
                this.showTwo = true;
                this.showThree = false;
            } else if (i == 2) {
                this.barwidth = 3;
                this.showOne = false;
                this.showTwo = false;
                this.showThree = true;
                this.prompt = false;
            }
        }
    },
    mounted() {
        this.safe();
    },
    updated() {
        this.safe();
    }
};
</script>
<style lang="scss" scoped>
.left-safe {
    float: left;
    margin: 20px;
    min-width: 400px;
    height: 370px;
    border: 1px solid #dcdcdc;
    .safe-head {
        width: 100%;
        height: 100px;
        background-color: rgb(247, 247, 247);
        border-bottom: 1px solid #dcdcdc;
        img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            float: left;
            margin: 20px;
        }
        .username {
            float: left;
            margin-top: 20px;
            width: 250px;
            height: 60px;
            p {
                text-align: left;
                font-size: 14px;
                line-height: 20px;
            }
            h2 {
                text-align: left;
                font-size: 18px;
                line-height: 30px;
            }
        }
    }
    .safe-body {
        overflow: hidden;
        width: 100%;
        height: 240px;
        .body-left {
            float: left;
            width: 100px;
            height: 150px;
            padding: 10px 5px;
            p {
                font-size: 14px;
                line-height: 60px;
                color: rgb(161, 161, 161);
            }
        }
        .body-right {
            float: left;
            padding-top: 10px;
            width: 290px;
            height: 170px;
            p {
                text-align: left;
                font-size: 14px;
                line-height: 60px;
            }
            ul {
                overflow: hidden;
                margin-top: 10px;
                width: 100%;
                color: rgb(161, 161, 161);
                li {
                    float: left;
                    margin-top: 10px;
                    padding: 0px 17px;
                    border-left: 1px solid rgb(230, 230, 230);
                    border-right: 1px solid rgb(230, 230, 230);
                    font-size: 14px;
                }
                li:nth-child(2) {
                    border-left: none;
                    border-right: none;
                }
            }
            p:nth-child(2) {
                margin-bottom: 25px;
            }
        }
    }
    .safe-footer {
        transform: translateX(-1px);
        width: 100%;
        height: 28px;
        line-height: 28px;
        border: 1px solid rgb(251, 236, 203);
        background-color: rgb(252, 248, 226);
        text-align: left;
        color: rgb(246, 131, 0);
        img {
            float: left;
            margin: 5px;
            margin-left: 15px;
        }
    }
}
.level-one {
    color: rgb(255, 102, 102);
}
.level-two {
    color: #f68300;
}
.level-three {
    color: rgb(0, 153, 0);
}
</style>
